import { Icon } from "@chakra-ui/react";
import React from "react";

const SendIcon = (props) => (
  <Icon viewBox="0 0 17 14" {...props}>
    <path d="M0 14V8.75L7.1579 7L0 5.25V0L17 7L0 14Z" fill="currentColor" />
  </Icon>
);

export default React.memo(SendIcon);
